import { PanelTable } from '../../../../SearchPanel/PanelTable';
import { getColumns } from './DealsTable.consts';
import { useVendorsStore } from '@/stores/VendorsStore';

export const DealsTable: React.FC = () => {
  const deals = useVendorsStore((state) => state.deals);
  return <PanelTable data={deals} columns={getColumns()} />;
};
